import React from 'react';
import { buildLoyaltyPointsMessage } from 'utils/loyaltyUtils';
import classes from './LoyaltyPointsBanner.module.scss';

interface Props {
    pointsToEarn: number;
}

export const LoyaltyPointsBanner: React.FC<Props> = ({ pointsToEarn }) => {
    return (
        <div className={classes.root}>
            <span className={classes.icon}>🎁</span>
            <span className={classes.text}>{buildLoyaltyPointsMessage(pointsToEarn)}</span>
        </div>
    );
};
